<template>
  <router-link v-if="provider.slug" :to="providerView">
    <el-card :body-style="bodyStyle" shadow="never" class="mb-40">
      <el-row>
        <el-col
          :class="[
            isFilterVisible
              ? 'thumbnail__dimension'
              : 'thumbnail__dimension--non-filter',
          ]"
        >
          <div
            class="thumbnail-image"
            v-bind:style="{ backgroundImage: 'url(' + thumbnail + ')' }"
          ></div>
        </el-col>
      </el-row>

      <el-row>
        <el-col class="provider-content mt-10">
          <div class="subtitle1 text-left">
            {{ providerName }}
          </div>
          <div class="subtitle2 subtitle2--light text-left">
            {{ origin }}
          </div>
        </el-col>
      </el-row>
    </el-card>
  </router-link>
</template>

<script>
import { get, head } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";

import imgProviderDefault from "@/assets/images/provider/provider-default.png";

export default {
  props: {
    provider: {
      type: Object,
      default: () => {},
    },
    isFilterVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    images() {
      return {
        providerDefault: {
          src: imgProviderDefault,
        },
      };
    },
    providerView() {
      return {
        name: "provider",
        params: {
          slug: get(this.provider, "slug", ""),
        },
      };
    },
    providerName() {
      return get(this.provider, "name");
    },
    origin() {
      const originHead = head(this.provider.origins);
      const country = get(originHead, "country.name");
      const region = get(originHead, "region.name", "");
      return originHead && `${country}, ${region == null ? "" : region}`;
    },
    thumbnail() {
      const thumbnail = get(this.provider, "mainImage.thumbnailLink");

      if (thumbnail == null) {
        return this.images.providerDefault.src;
      }

      return thumbnail;
    },
    bodyStyle() {
      if (!layoutUtils.isMobileLayout(this.$mq) && !this.isFilterVisible) {
        return {
          padding: "0 0 0 20px",
        };
      }
      return {
        padding: "0px",
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";

a {
  text-decoration: none;
  color: inherit;
}
.el-card {
  border-radius: 0;
  border: 0;
  text-align: center;
}
.provider__origin {
  color: $color-on-background-area1 !important;
}
.subtitle2--light {
  color: $color-on-background-area1;
}
.provider-content {
  height: 60px;
}
.thumbnail-image {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
